import { FormItem, SurveyDefinition, SurveyStepDefinition } from '../types/Survey';

export interface IdentifierSource {
    type: 'Step' | 'FormItem' | 'CalculatedField';
    parentIdentifier?: string;
    name: string;
}

export interface Identifier {
    identifier: string;
    sources: IdentifierSource[];
}

export function getResultIdentifiersWithProvenance(survey: SurveyDefinition): Identifier[] {
    const identifierLookup: Record<string, Identifier> = {};

    const stepTypesWithResults = ['QuestionStep', 'WebViewStep', 'ConsentStep', 'ConsentReviewStep', 'YouTubeStep', 'CelebrationStep', 'ConnectEhrStep', 'ConnectDeviceAccountStep'];

    survey.steps?.forEach(step => {
        if (hasFormItems(step)) {
            step.formItems?.forEach(formItem => {
                identifierLookup[formItem.identifier] ??= { identifier: formItem.identifier, sources: [] };
                identifierLookup[formItem.identifier].sources.push({ type: 'FormItem', parentIdentifier: step.identifier, name: formItemReadableName(step, formItem) });
            });
        } else if (stepTypesWithResults.includes(step.type) && step.identifier) {
            identifierLookup[step.identifier] ??= { identifier: step.identifier, sources: [] };
            identifierLookup[step.identifier].sources.push({ type: 'Step', name: step.identifier });
        }
    });

    survey.calculatedFields?.forEach(field => {
        identifierLookup[field.identifier] ??= { identifier: field.identifier, sources: [] };
        identifierLookup[field.identifier].sources.push({ type: 'CalculatedField', name: field.identifier });
    });

    return Object.values(identifierLookup);
}

export function getResultIdentifiers(survey: SurveyDefinition): string[] {
    return getResultIdentifiersWithProvenance(survey).map(identifier => identifier.identifier);
}

export function hasFormItems(step: SurveyStepDefinition): step is SurveyStepDefinition & { formItems: FormItem[] } {
    return ['InstructionStep', 'FormStep', 'ConsentFormStep'].includes(step.type);
}

export function formItemReadableName(step: SurveyStepDefinition, formItem: FormItem): string {
    return `${step.identifier || 'Unknown'} > ${formItem.identifier}`;
}